import { PhoenixToggleService } from 'phoenix/services/phoenixToggleService';

export function FeatureToggleDirective(pxPhoenixToggleService:PhoenixToggleService):ng.IDirective {
    return {
        restrict: 'A',
        link: function(scope, element, attrs) {
            if(!this.name) {
                throw new Error('Cannot get directive name.');
            }
        
            const displayOriginal = createDisplayRestorer(element);
            const removeElement = createElementRemover(element);

            element.css('display', 'none');
            let featureName = attrs[this.name];
            let invertLogic = attrs.invertToggle ? attrs.invertToggle.toLowerCase() === 'true' : false;
            let featureOn = invertLogic ? removeElement : displayOriginal;
            let featureOff = invertLogic ? displayOriginal : removeElement;

            pxPhoenixToggleService
                .with(featureName)
                .on(featureOn)
                .off(featureOff);
        }
    }
}

function createDisplayRestorer(element:JQLite) {
    let existingDisplay =  element.css('display') || '';
    return () => element.css('display', existingDisplay);
};

function createElementRemover(element:JQLite){
    return () => element.remove();
}

FeatureToggleDirective.$inject = [
    'pxPhoenixToggleService'
];


// WEBPACK FOOTER //
// ./src/phoenix/components/featureToggle/featureToggle.ts